// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMMENT_DELETED = "Odpov\u011b\u010f byla smazan\u00e1";
